// Imports => React
import React, {useMemo, memo} from 'react';
import {Props} from './ac-divider.proptypes';
import clsx from 'clsx';

// Imports => Utilities
import {AcGenerateThemeClassNames} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-divider',
  FAT: 'ac-divider--fat',
  VARIANT: {
    SOLID: 'ac-divider--solid',
    DASHED: 'ac-divider--dashed',
    DOTTED: 'ac-divider--dotted',
  },
  THEME: AcGenerateThemeClassNames('ac-divider'),
};

const AcDivider = memo(({theme = 'pitch', variant = 'solid', fat = false, className}) => {
  const getMainClassNames = useMemo(() => {
    return clsx(
      _CLASSES.MAIN,
      theme && _CLASSES.THEME[theme.toUpperCase()],
      variant && _CLASSES.VARIANT[variant.toUpperCase()],
      fat && _CLASSES.FAT,
      className
    );
  }, [theme, variant, fat, className]);

  return <div className={getMainClassNames} />;
});

AcDivider.displayName = 'AcDivider';
AcDivider.propTypes = Props;

export {AcDivider};
export default AcDivider;
